
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./Pages/Home";
import About from './Pages/About'
import Story from "./Pages/Story";
import Team from './Pages/Team'
import Yonja from './Pages/Yonja';
import Sanyuka from './Pages/sanyuka';
import Vocational from './Pages/Vocational';
import NewNormals from './Pages/NewNormals';
import Error from "./Pages/Error"
import WeDoIt from './Pages/WeDoIt';
import WhereWeDoIt from './Pages/Where';
import Intervene from './Pages/Intervene';
import Contact from './Pages/Contact';
import Club from './Pages/Club';
import FundWork from './Pages/FundWork';
import FeedPoor from './Pages/FeedPoor';
import Documents from './Pages/Documents';
import KayungaConnect from './Pages/KayungaConnect';
import VugaNange from './Pages/VugaNange'
import Sacco from './Pages/Sacco';
import Book from './Pages/Books';
import Community from './Pages/Community';
import Liquid from './Pages/Liquid';
import Tufayo from './Pages/Tufayo';
import HIV from './Pages/HIV';
import Dress from './Pages/Dress';

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route exact path={["/", "/home", "/index.html"]} element={<Home />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/story" element={<Story />} />
        <Route exact path="/members" element={<Team />} />
        <Route exact path="/project-yonja" element={<Yonja />} />
        <Route exact path="/project-sanyuka" element={<Sanyuka />} />
        <Route exact path="/project-mynewnormals" element={<NewNormals />} />
        <Route exact path="/project-disability" element={<Vocational />} />
        <Route exact path="/us-we-do-it" element={<WeDoIt />} />
        <Route exact path="/us-we-work" element={<WhereWeDoIt />} />
        <Route exact path="/us-intervene" element={<Intervene />} />
        <Route exact path="/contact-us" element={<Contact />} />
        <Route exact path="/community-club" element={<Club />} />
        <Route exact path="/fund-our-work" element={<FundWork />} />
        <Route exact path="/feed-our-souls" element={<FeedPoor />} />
        <Route exact path="/publications" element={<Documents />} />
        <Route exact path="/kayungaconnect" element={<KayungaConnect />} />
        <Route exact path="/kayungacycling" element={<VugaNange />} />
        <Route exact path="/sacco" element={<Sacco />} />
        <Route exact path="/community-book" element={<Book />} />
        <Route exact path="/community-maama-kit" element={<Community />} />
        <Route exact path="/community-liquid-soap" element={<Liquid />} />
        <Route exact path="/community-tufayo" element={<Tufayo />} />
        <Route exact path="/community-hiv" element={<HIV />} />
        <Route exact path="/community-dress" element={<Dress />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default App;